import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './save-preparation-item-confirm-dialog.controller';
import template from './save-preparation-item-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, auditId, statuses, users, preparationItem
  }) {
    return {
      controller,
      controllerAs: 'savePreparationItemConfirmDialogVM',
      locals: {
        customerId,
        auditId,
        statuses,
        users,
        preparationItem
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.savePreparationItemConfirmDialog', [
  alerts,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('savePreparationItemConfirmDialog', dialogService)
  .name;
